export default __webpack_public_path__ + "static/media/badges.cf3f4589.png";